import { connect } from 'react-redux'
import ProductPane from '../../components/products/details/product/edit/ProductPane'
import * as actions from '../../state/actions/provider-products/index'
import { IStoreState } from '../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    productId: ownProps.productId,
    location: ownProps.location,
    product: Object.values(state.providerProduct.items).filter(it => it.id === ownProps.productId)[0],
    integrations: state.integrations.items,
    serviceLevels: state.globalSettings.serviceLevels.items
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchProduct: (productId: string) => {
      return dispatch(actions.fetchProduct(productId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductPane)



// WEBPACK FOOTER //
// ./src/containers/products/ProviderProductInfoEdit.ts